import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/results";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/results")(
  enRouteOptions(routeOptions, {
    svPath: "/results",
    title: 'Your Result – Alkoholprovet',
    description: 'Your result after a practice session or mock exam.',
    noindex: true,
  }),
);
